import { gql } from "@apollo/client";

export const CREATE_SCHOOL = gql`
  mutation CreateSchool($input: CreateSchoolInput) {
    createSchool(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_SCHOOL_WITH_PAGINATION = gql`
  query GetSchoolPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
  ) {
    getSchoolPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
    ) {
      data {
        _id
        school_name
        school_name_en
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_SCHOOL = gql`
  mutation UpdateSchool($id: ID, $input: CreateSchoolInput) {
    updateSchool(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DELETE_SCHOOL = gql`
  mutation DeleteSchool($id: ID) {
    deleteSchool(_id: $id) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;
